// extracted by mini-css-extract-plugin
export default {"benefitsContainer":"IRdWhP","icon":"_uDbWr","underline":"_D4mMd"};